import React from 'react';
import { Hero } from '../components/Hero';
import { HowItWorks } from '../components/HowItWorks';
import { OurServices } from '../components/OurServices';
import { Pricing } from '../components/Pricing';
import { WhyThisWorks } from '../components/WhyThisWorks';
import { ProofSection } from '../components/ProofSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { Navbar } from '../components/Navbar';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-white selection:bg-neutral-900 selection:text-white" data-id="element-165">
      <Navbar data-id="element-166" />
      <Hero data-id="element-167" />
      <HowItWorks data-id="element-168" />
      <OurServices data-id="element-169" />
      <Pricing data-id="element-170" />
      <WhyThisWorks data-id="element-171" />
      <ProofSection data-id="element-172" />
      <FinalCTA data-id="element-173" />
      <Footer data-id="element-174" />
    </main>;
}